import { mapActions, mapGetters } from 'vuex';
import { Logger } from '@vue-storefront/core/lib/logger'

/**
 * Component responsible for displaying single user order. Requires User module.
 */
export const UserSingleOrder = {
  name: 'UserSingleOrder',
  data () {
    return {
      items: [],
      products: {},
      count: 0,
      loader: false,
      timeout: null
    }
  },
  computed: {
    ...mapGetters({
      oneOrder: 'user/getOrder'
    }),
    currentUser () {
      return this.$store.state.user.current
    },
    ordersHistory () {
      return this.$store.state.user.orders_history
    },
    order () {
      return this.oneOrder
    },
    paymentMethod () {
      return this.order.payment.additional_information[0]
    },
    billingAddress () {
      return this.order.billing_address
    },
    shippingAddress () {
      return this.order.extension_attributes.shipping_assignments[0].shipping.address
    },
    getPartialReturnExist () {
      return this.order.refunded > 0 && this.order.refunded < this.order.original_grand_total
    },
    getFullRefund () {
      return this.order.refunded === this.order.original_grand_total
    },
    orderId () {
      return parseInt(this.$route.params.orderId);
    }
  },
  beforeDestroy () {
    if (this.timeout) clearTimeout(this.timeout);
  },
  methods: {
    ...mapActions({
      getOneOrder: 'user/getOneOrder',
      OnAndOffLoader: 'ui/OnAndOffLoader',
      changeLocation: 'locations/setCurrentLocation',
      ensureCurrentPartner: 'partners/ensureCurrentPartner'
    }),
    async loadOrder () {
      this.OnAndOffLoader(true);
      await this.getOneOrder(this.orderId).then(() => {
        if (!Object.keys(this.order).length) {
          this.$router.push('/page-not-found')
        } else {
          return this.changeLocation({ code: this.order.location_code, forceCategoriesLoad: true })
            .then(() => this.ensureCurrentPartner({ code: this.order.partner_code, locationCode: this.order.location_code }))
        }
      }).finally(() => {
        this.OnAndOffLoader(false);
      })
    },
    async loadProducts(){
      await this.$store.dispatch(
        'user/getOrderItems',
        this.orderId
      ).then(async resp => {
        this.items = resp
        return resp
      }).catch(error => {
        Logger.error('Cannot load order items ', error)()
        this.items = []
        return []
      });
    },
    async openModal (orderId) {
      this.$bus.$emit('notification-progress-start', this.$t('Please wait we are loading your products...'))
      let availableProducts = [];
      let notAvailableProducts = [];
      this.$store.commit('ui/setLoader', true)
      this.$store.dispatch(
        'user/getOrderItemsForReorder',
        this.orderId
      ).then(async resp => {
        this.$bus.$emit('notification-progress-stop')
        this.count = resp.available.length + resp.unavailable.length;
        this.productsForReorder = { available: resp.available, notAvailable: resp.unavailable, count: this.count }
        this.$bus.$emit('modal-toggle', 'reorder-list' + orderId)
      }).catch(error => {
        Logger.error('Cannot load order items for reordering ', error)()
      }).finally(() => {
        this.$store.commit('ui/setLoader', false)
      })
    },
    async remakeOrder (products) {
      this.$bus.$emit('notification-progress-start', this.$t('Please wait ...'))
      await this.$store.dispatch('cart/addItems', { products })
      this.$bus.$emit('modal-hide', 'reorder-list')
      this.$bus.$emit('notification-progress-stop', {})
      // Redirect to the cart straight away.
      this.$router.push(this.localizedRoute('/checkout'))
    },
    skipGrouped (items) {
      return items.filter((item) => {
        return !item.parent_item_id
      })
    },
    async loadOrderPage () {
      this.loader = true;
      await Promise.all([
        this.loadOrder(),
        this.loadProducts()
      ]).finally(() => {
        this.loader = false;
      });
    }
  }
}
